import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label, TextField } from 'cw-ui-core';
import React, { useEffect } from 'react';
import layoutCss from 'src/styles/layout.scss';
import css from './SupportEnabledDialog.scss';
import Locale from 'src/i18n';
import TextButton from '../../../../components/TextButton';

export const SUPPORT_ENABLED_DIALOG = 'SUPPORT_ENABLED_DIALOG';

const SupportEnabledDialog = ({ intl, onDidMount, onCopyPassword, onClose, password }) => {
    useEffect(() => {
        onDidMount();
    }, [onDidMount]);

    const { formatMessage } = intl;

    const dialogButtons = [
        <TextButton key="copy" automationName="copy" text={formatMessage(Locale.copy)} onClick={onCopyPassword} />,
        <TextButton key="close" automationName="close" text={formatMessage(Locale.close)} onClick={onClose} />,
    ];

    return (
        <Dialog
            dialogId={SUPPORT_ENABLED_DIALOG}
            header={formatMessage(Locale.connectWiseSupport)}
            buttons={dialogButtons}>
            <br />
            <div className={css.wrap}>
                <div className={layoutCss.podCol}>
                    <ScreenMessagePanelContainer className={css.screenMessage} screenKey={SUPPORT_ENABLED_DIALOG} />
                    <Label>{formatMessage(Locale.supportEnabled)}</Label>
                    <TextField className={css.password} value={password} />
                </div>
            </div>
        </Dialog>
    );
};

export default injectIntl(SupportEnabledDialog);
